import React, { useState, useEffect, useContext, Component } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import LoginPageRouted from './components/LoginPageRouted';
import RankingPage from './components/RankingPage';
import { Navigate, useNavigate } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SettingsPage from './components/SettingsPage';
// import { AuthContext } from './components/AuthContext';


import './custom-table-header.css';
import './progress_blur.css';
import './transitions.css';
import ModernLoginPage from "./components/ModernLoginPage";
import SignupPage from './components/SignupPage';
import SubscriptionPlansPage from './components/SubscriptionPlansPage';
import PaymentSuccessPage from './components/PaymentSuccessPage';
import PrescreenPortalPage from './components/PrescreenPortalPage';

const backend_url = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5001'

const App = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const handleLogout = () => {
    // Remove authentication token from localStorage
    // localStorage.removeItem('newCookie');
    setLoggedIn(false);
    deleteCookie('userSession')
    console.log("********************************************")
    console.log("userSession cookie has been deleted.")
    console.log("********************************************")
    navigate('/login'); 
  };

  const getCookie = (name) => {
    let match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)')); // checks from brower
    console.log("Found existing cookie with value: ", match ? match[1] : null)
    return match ? match[1] : null;
}

  const setCookie = (name, value) => {
    const date = new Date();
    const daysToExpire = 1
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    let expires = "expires=" + date.toDateString();
    document.cookie = `${name}=${value}; ${expires}; path=/`
    console.log( `setCookie completed with cookie: ${name}=${value}`)
  }

  const deleteCookie = (name) => {
    setCookie(name, null, null);
  }

  const checkCookieValidity = async (cookieValue) => {
    // let cookieValue = "9a08c4cb-ee6d-48e6-bb58-970d94ad7053%0A"
    let isValidCookie = false
    // console.log("initial cookie value: ", cookieValue)
    try {
      const response = await axios({
        method: 'post',
        url: backend_url + '/v1/validate-cookie', // Replace with your actual API endpoint
        data: {
          Cookie: cookieValue
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log("response.data: ", response.data)
      if (response.data.Valid) {
        isValidCookie = true
        setCookie("userSession", cookieValue)
        console.log('Cookie is valid');
      } else {
        console.log('Cookie is not valid');
      }
    } catch (error) {
      console.error('Error checking cookie validity', error);
    }
    return isValidCookie;
  };

  async function AuthCookie(){
    setLoading(true);
    // let response = axios.post(backend_url + 'language', {text_input: this.state.language, place: this.state.servicePlace})
    let loginCondition = false;
    let cookieValue = getCookie("userSession")
    console.log("==========================================================================")
    console.log("cookieValue: ", cookieValue)
    console.log("==========================================================================")
    if (cookieValue != null) {      
      // let isValidCookie = checkCookieValidity(cookieValue);
      let isValidCookie = await checkCookieValidity(cookieValue);
      console.log("isValidCookie: ", isValidCookie)
      if (isValidCookie === true){
        setLoggedIn(true);
      }
    }
    setLoading(false);
  }
  useEffect(() => {
    AuthCookie();
  }, []);
  
  const handleLoginComplete = (newCookieValue) => {
    console.log('Login process completed')
    // localStorage.setItem('newCookie', newCookieValue)
    setLoggedIn(true); 
    // setNewCookie(newCookieValue);
    setCookie("userSession", newCookieValue)
  }

  if (loading) {
    return <div></div>; // Potentially could do a loading spinner or something. Blank page liek this also looks pretty clean
  }

  return (
    <div className="App">
        <Routes >
          <Route path="/" element={<RankingPage onLogout={handleLogout} loggedIn={loggedIn}/>}/>
          <Route path="/login" element={<ModernLoginPage onLoginComplete={handleLoginComplete} loggedIn={loggedIn}/>} />
          <Route path="/settings" element={<SettingsPage onLogout={handleLogout} loggedIn={loggedIn} getCookie={getCookie}/>} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/subscription-plans" element={<SubscriptionPlansPage />} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/prescreen-portal" element={<PrescreenPortalPage />} />
        </Routes>
    </div>
  );
};

export default App;